import React from 'react';
import 'HELPDESK/CommonResources/DeleteTextModal/deletemodal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from '../ButtonLoader/ButtonLoader';

class DeleteTextModal extends React.Component {
    constructor(props) {
        super(props);
    }

    // METHOD TO DELETE SALARY COMPONENT
    deleteComponent = async (event) => {
        this.props.deleteComponent();
    }

    deleteCancel = () => {
        this.setState(
            this.initialState
        );
        this.props.visibility();
    }

    render() {
        return(
            <div className={this.props.showModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header modalHeader">
                            <div className="iconContainer" style={{ backgroundColor: '#FF0000' }}>
                                <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} size="lg" color='#FFFFFF' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Are You Sure ?</h3>
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p className="note-text">
                                {this.props.deleteKey} once deleted cannot be retrieved.
                            </p>
                            <p className="note-text">
                                All data associated with {this.props.deleteKey.toLowerCase()} will be deleted permanently.
                            </p>
                        </div>

                        <div className="modal-footer">

                            <div id="addAssetButtonContainer">
                                {
                                    this.props.deleting &&
                                        <ButtonLoader />
                                }
                                <button className="btn delete-outline-button waves-effect" onClick={() => this.deleteComponent()} disabled={this.props.deleting}>Yes</button>
                                <button className="btn delete-primary-button" onClick={() => this.deleteCancel()}>No</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteTextModal;